import { render } from "./VsPrompt.vue?vue&type=template&id=4634b761"
import script from "./VsPrompt.vue?vue&type=script&lang=js"
export * from "./VsPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__